import React from 'react';
import ReactDOM from 'react-dom';
import { StoreProvider } from 'easy-peasy';
import { ThemeProvider } from 'emotion-theming';

import Store from './store';
import theme from './theme';
import App from '~/components/App';

function renderWithStore(children, id) {
  const domEl = document.getElementById(id);

  if (domEl) {
    ReactDOM.render(
      <StoreProvider store={Store}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </StoreProvider>,
      domEl
    );
  }
}

function init() {
  renderWithStore(<App />, 'app');
}

export default {
  init,
};
